
import { Component, OnInit, Input } from '@angular/core';
import { imgCardDrop } from '../../classes/animations';
import { FormControl } from '@angular/forms';
import { AlertService } from '../../services/alert.service';
import { TRANSLATE } from '../../classes/translatable';
import { ContactTypeService } from '../../../identite/shared/services/contact-type.service';
import { ContactType } from '../../../identite/shared/classes/contact-type';
import { AclAccess } from '../../../configuration/shared/classes/acl_access';
import { StorageService } from '../../services/storage.service';

@Component({
    selector: 'app-admin-list-contact-type',
    templateUrl: './admin-list-contact-type.component.html',
    styleUrls: ['./admin-list-contact-type.component.css'],
    animations: [imgCardDrop]
})
export class AdminListContactTypeComponent implements OnInit {

    contactTypes: any[];
    lstPays: any[];
    newContactType = new ContactType();
    selected = new FormControl(0);

    aclConfig: AclAccess;

    @Input()
    triggerReload: () => void;

    constructor(
        private contactTypeService: ContactTypeService,
        private alertService: AlertService,
        private storageService: StorageService
    ) { }

    ngOnInit() {
        this.aclConfig  = new AclAccess(this.storageService.getAcl('configuration'));
        this.contactTypes = [];
    }


    getEtatsIdentite() {
        this.contactTypes = [];
        this.contactTypeService.getContactType()
            .subscribe(retour => {
                if (retour.status === 200) {
                    retour.data.forEach(element => {
                        this.contactTypes.push(new ContactType(element));
                    });
                }
            });
    }


    selectTab(event: any) {
        this.selected.setValue(event);
        if (event === 1) {
            this.getEtatsIdentite();
        }
    }

    insertContactType(type: ContactType) {
        this.contactTypeService.insertContactType(type)
            .subscribe(retour => {
                if (retour.status === 200) {
                    this.newContactType = new ContactType();
                    this.alertService.success(TRANSLATE('Catégorie ajoutée avec succès'));
                    if (this.triggerReload) {
                        this.triggerReload();
                    }
                } else {
                    this.alertService.error(TRANSLATE(retour.message));
                }
            });
    }

    updateContactType(type: ContactType) {
        this.contactTypeService.updateContactType(type.ctp_id, type)
            .subscribe(retour => {
                if (retour.status === 200) {
                    this.alertService.success(TRANSLATE('Catégorie modifiée avec succès'));
                    if (this.triggerReload) {
                        this.triggerReload();
                    }
                } else {
                    this.alertService.error(TRANSLATE(retour.message));
                }
            });
    }

    deleteContactType(type: ContactType) {
        this.contactTypeService.deleteContactType(type.ctp_id)
            .subscribe(retour => {
                if (retour.status === 200) {
                    this.alertService.success(TRANSLATE('Catégorie supprimée avec succès'));
                    this.getEtatsIdentite();
                    if (this.triggerReload) {
                        this.triggerReload();
                    }
                } else {
                    this.alertService.error(TRANSLATE(retour.message));
                }
            });
    }

}
